import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_URL ||
  "https://5eef-2405-201-2001-483f-72b1-513-40ab-1f7.ngrok-free.app";

// const baseURL = "https://85f02e99294a59.lhr.life";

const axiosInstance = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "69420",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      //   window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
